import React from 'react';
import ThumbnailWrapper from './ThumbnailWrapper';
/**
 * Single placelholder for embed feed.
 */
const Placeholder = ({ isLarge, isSmall, mode, }) => {
    return (<ThumbnailWrapper isPlaceholder isLarge={isLarge} mode={mode} isSmall={isSmall}></ThumbnailWrapper>);
};
export default Placeholder;
